module.exports = __webpack_public_path__ + "img/number-graph.281fecc9.png";